import { AxiosResponse } from 'axios';

import $api from '@/http/index';

export class TechSupportService {
    static async getTextInfo(): Promise<AxiosResponse<string>> {
        return $api.get<string>(`/techSupport/textInfo`);
    }
}
